<template>
	<div class="container">
		<div class="grid-form">
			<div class="grid-form-item">
				<div class="grid-flex-hd">姓名</div>
				<div class="grid-flex-td">
					{{user.realname}}
				</div>
			</div>
			<div class="grid-form-item">
				<div class="grid-flex-hd">手机号</div>
				<div class="grid-flex-td">
					{{user.mobile}}
				</div>
			</div>
			<div class="grid-form-item">
				<div class="grid-flex-hd">居住地</div>
				<div class="grid-flex-td">
					{{user.address}}
				</div>
			</div>
			<div class="grid-form-item">
				<div class="grid-flex-hd">邮箱地址</div>
				<div class="grid-flex-bd">
					<input type="text" v-model="email" placeholder="请填写邮箱地址" placeholder-style="color:#C7C7C7" />
				</div>
			</div>
		</div>
		<div class="grid-form-btn">
			<div class="btn-medium" @click="submit">保存</div>
		</div>
	</div>
</template>
<script>
	//import commons from '@/rencai/static/js/common.js'
	//    import {rcuserUser,rcuserRclogin,updateUser} from "../../static/api/rencai.js"

	export default {
		data() {
			return {
				email: '',
				user: {},
				avatarUrl: ''
			}
		},
		onLoad() {
			const _this = this
			this.$wx.getUserinfo((user) => {
				let resobj = user.data ? user.data : {};
				if (resobj) {
					_this.user = resobj;
					let userinfo = JSON.parse(uni.getStorageSync('userinfo') || '{}');
					_this.avatarUrl = userinfo.userInfo.avatarUrl;
				}
			}, true);
		},
		methods: {
			validate() {
				if (!commons.isEmail(this.email)) {
					return false;
				}
				return true;
			},
			submit() {
				if (!this.validate()) return;
				let that = this;
				if (that.user.rc_user == 1) {
					let result = {
						email: that.email,
						img_url: that.avatarUrl,
						realname: that.user.realname,
						address: that.user.address,
						mobliphone: that.user.mobile,
						user_id: that.user.id,
					};
					// 修改用户信息
					updateUser(result).then(res => {
						uni.hideLoading()
						let mini_user = async function() {
							return await rcuserRclogin(that.user.mobliphone)
						}
						// 调起消息订阅界面
						wx.requestSubscribeMessage({
							tmplIds: ['K0yyWh9mEwZ68U9ssokSfMfvmumcbHNkMbOOpX1BwRI'],
							success(res) {},
							complete: (errMsg) => {
								uni.showToast({
									title: "欢迎使用东楚通人才网",
									icon: "success",
									position: "center",
									success: () => {
										setTimeout(function() {
											uni.removeStorageSync('user');
											uni.removeStorageSync('token');
											uni.reLaunch({
												url: '/rencai/user/wode'
											})
										}, 1000)
									}
								})
							}
						})
					})
				} else {
					let result = {
						email: that.email,
						user_id: that.user.id,
						img_url: that.avatarUrl
					};
					// 账号注册
					rcuserUser(result).then(res => {
						let mini_user = async function() {
							return await rcuserRclogin(result.phone)
						}
						// 调起消息订阅界面
						wx.requestSubscribeMessage({
							tmplIds: ['K0yyWh9mEwZ68U9ssokSfMfvmumcbHNkMbOOpX1BwRI'],
							success(res) {},
							complete: (errMsg) => {
								uni.showToast({
									title: "欢迎使用东楚通人才网",
									icon: "success",
									position: "center",
									success: () => {
										setTimeout(function() {
											uni.removeStorageSync('user');
											uni.removeStorageSync('token');
											uni.reLaunch({
												url: '/rencai/user/wode'
											})
										}, 1000)
									}
								})
							}
						})
					})
				}
			},
		}
	}
</script>
<style scoped>
	.container{
		padding:20px;
	}
	.grid-form {
		font-size: 15px;
	}

	.grid-form-item {
		border-bottom: 1px solid #ECECEC;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 16px;
	}

	.grid-form-item .grid-flex-hd {
		width: 80px;
		padding: 16px 0;
	}

	.grid-form-item .grid-flex-bd,
	.grid-form-item .grid-flex-hd {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		word-wrap: normal;
		word-wrap: break-word;
		word-break: break-all;
	}

	.grid-form-item .grid-flex-td {
		padding: 16px 0;
		text-align: left;
		flex: 1;
	}

	.grid-flex-bd {
		flex: 1;
	}

	.grid-form-btn {
		width: 50%;
		margin: 24px auto;
	}

	.btn-medium {
		display: block;
		border-radius: 39px;
		height: 39px;
		padding: 0;
		line-height: 38px;
		text-align: center;
		font-size: 15px;
		background-color: #387CFB;
		border: 1px solid #387CFB;
		color: #FFFFFF
	}
</style>
